import React from "react";
import { Routes as RouterRoutes, Route } from "react-router-dom";
import Login from "../pages/login/Login";
import AppSelectionPage from "../pages/login/AppSelectionPage";
import ProtectedRoute from "../pages/login/ProtectedRoute";
import Home from "../pages/home/Home";
import Feature from "../pages/feature/Feature";
import Role from "../pages/role/Role";
import Users from "../pages/Users/Users";
import AddUser from "../pages/Users/AddUser";
import Driver from "../pages/driver/Driver";
import AddDriver from "../pages/driver/AddDriver";
import Site from "../pages/site/Site";
import AddSite from "../pages/site/AddSite";
import RegisterOrganization from "../pages/organization/register/RegisterOrg";
import StopsScreen from "../pages/stops/StopsScreen";
import RouteScreen from "../pages/Routes/RouteScreen";
import Organization from "../pages/organization/Organization";
import AddOrganization from "../pages/organization/addOrganization/AddOrganization";
import FeatureAssignment from "../pages/organization/featureAssign/FeatureAssignment";
import RoleAccess from "../pages/role/RoleAccess";
import AddAdmin from "../pages/organization/OrgAdmin";
import Alert from "../pages/alerts/Alert";
import Overview from "../pages/dashboard/dashboarddata/Overview";
import ManageData from "../pages/Managedata/managedata";
import Vehicle from "../pages/vehicle/Vehicle";
import Routess from "../pages/Routes/Routess";
import Stops from "../pages/stops/Stops";
import Schedule from "../pages/Schedule/Schedule";
import AddSchedule from "../pages/Schedule/AddSchedule";
import VehicleScreen from "../pages/vehicle/VehicleScreen";
import AddRoute from "../pages/Routes/addRoute/AddRoute";
// Import components from Content.js
import StopAddUpdatePage from "../pages/new/StopAddUpdatePage";
import RouteAddPage from "../pages/new/RouteAddPage";
import AllRouteTrack from "../pages/new/AllRouteTrack";
import VehicleAddPage from "../pages/new/VehicleAddPage";
import VehicleAllTracker from "../pages/vehicle/VehicleAllTrack";
import AllStopsMapPage from "../pages/stops/AllStops";
import VehicleTrackingPage from "../pages/new/VehicleTrackingPage";
import RouteTrackingPage from "../pages/new/RouteTrackingPage";
import DeviceLocationMap from "../pages/vehicle/VehicleTracker";
import RouteTrackingComponent from "../pages/Routes/RouteTracking";
import RouteSchedules from "../pages/Routes/routesSchedule.js/RouteSchedules";
import MapPage from "../pages/stops/mapPage";
import AddVehicle from "../pages/vehicle/addVehicle/AddVehicle";
// New Design Pages
import DashboardPage from "../pages/new/DashboardPage";
import VehiclePage from "../pages/new/VehiclePage";
import RoutePage from "../pages/new/RoutePage";
import StopPage from "../pages/new/StopPage";
import AlertPage from "../pages/new/AlertPage";
import SchedulePage from "../pages/new/SchedulePage";
import DriverPage from "../pages/new/DriverPage";
import AttendantPage from "../pages/new/AttendantPage";
import SitePage from "../pages/new/SitePage";
import UserPage from "../pages/new/UserPage";
import ManageDataPage from "../pages/new/ManageDataPage";
import RolePage from "../pages/new/RolePage";
import RoleAssignPage from "../pages/new/RoleAssignPage";
import OrganizationPage from "../pages/new/OrganizationPage";
import RegisterOrganizationPage from "../pages/new/RegisterOrganizationPage";
import RegisterConfirmationPage from "../pages/new/RegisterConfirmationPage";
import RegisterMoreDetailsPage from "../pages/new/RegisterMoreDetailsPage";
import RegisterFeaturePage from "../pages/new/RegisterFeaturePage";
import RegisterNeedInfoPage from "../pages/new/RegisterNeedInfoPage";
import OrganizationList from "../components/organization/OrganizationList";
import AdminDashboard from "../components/organization/AdminDashboard";
import AdminRequestPage from "../pages/new/AdminRequestPage";
import RequestDetails from "../components/organization/RequestDetails";
import OrganizationUpdate from "../components/organization/OrganizationUpdate";
import DriverAddPage from "../pages/new/DriverAddPage";
import DriverSelfRegisterPage from "../pages/driver/DriverSelfRegisterPage";
import SiteAddPage from "../pages/new/SiteAddPage";
import AdminAssignUpdate from "../pages/new/AdminAssignUpdate";
import AdminOrgMore from "../pages/new/AdminOrgMore";
import AdminOrgAssign from "../components/organization/AdminOrgAssign";
import StopScheduleDetails from "../pages/stops/StopsScheduleDetails/StopScheduleDetails";
import StopSchedulePage from "../pages/new/StopSchedulePage";
import ScheduleVehicle from "../components/vehicle/ScheduleVehicle";
import VehicleEntryExitPage from "../pages/new/VehicleEntryExitPage";
import AnalyticsEntryExitPage from "../pages/new/AnalyticsEntryExitPage";
import RouteSchedule from "../components/route/RouteSchedule";
import AppSetingsContainer from "../components/appSettings/AppSettingsContainer";
import LoginOtp from "../pages/login/LoginOtp";
import LoginPhone from "../pages/login/LoginPhone";
import DriverConsoleContainer from "../components/driverConsole/DriverConsoleContainer";
import DeviceListPage from "../pages/new/DeviceListPage";
import CreateDevicePage from "../pages/new/CreateDevicePage";
import DeviceMonitorPage from "../pages/new/DeviceMonitorPage";
import ResetPassword from "../pages/login/ResetPassword";
import ReportsPage from "../pages/new/ReportsPage";
import AlertContainer from "../components/alerts/AlertContainer";
import DriverBehaviorPage from "../pages/driverSafety/DriverBehaviorPage";
import TrackVehiclesPage from "../pages/new/TrackVehiclesPage";
import StopsAllTrack from "../pages/new/StopsAllTrack";
import DashboardMapFilter from "../components/dashboard/DashboardMapFilter";
import DashboardMapURL from "../components/dashboard/DashboardMapURL";
import ReplayVehicle from "../components/reports/ReplayVehicle";
import AnalyticsPage from "../pages/new/AnalyticsPage";

import MobileStopScreen from "../components/stops/mobileStops/MobileStopScreen";
import BusList from "../components/stops/mobileStops/BusList";

import SchoolDashboard from "../pages/schoolDashboard/Dashboard";
import SchoolStudents from "../pages/schoolStudents/Students";
import SchoolVehicles from "../pages/schoolVehicles/Vehicles";
import SchoolAttendants from "../pages/schoolAttendants/Attendants";
import SchoolRoutes from "../pages/schoolRoutes/Routes";
import SchoolStops from "../pages/schoolStops/Stops";
import SchoolDrivers from "../pages/schoolDrivers/Drivers";
import ParentView from "../pages/parentView/ParentView";
import SchoolReports from "../pages/schoolReports/SchoolReports";
import SchoolAlerts from "../pages/schoolAlerts/SchoolAlerts";
import SchoolUsers from "../pages/schoolUsers/SchoolUsers";
import SchoolSites from "../pages/schoolSites/SchoolSites";
import SchoolSchedules from "../pages/schoolSchedules/SchoolSchedules";
import SchoolSettingsContainer from "../pages/schoolSettings/SchoolSettingsContainer";

import SchoolStopMonitor from "../pages/schoolStops/SchoolStopMonitor";

import SchoolVehicleMonitor from "../pages/schoolVehicles/SchoolVehicleMonitor";


import SchoolRouteMonitor from "../pages/schoolRoutes/SchoolRouteMonitor";

const Routes = () => {
  return (
    <RouterRoutes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/app-select" element={<ProtectedRoute><AppSelectionPage /></ProtectedRoute>} />
      <Route path="/otp-verify" element={<LoginOtp />} />
      <Route path="/auth-phone" element={<LoginPhone />} />

      {/* Authentication and Registration */}
      {/* <Route path="/register" element={<RegisterOrganization />} /> */}
      <Route path="/register" element={<RegisterOrganizationPage />} />
      <Route path="/registerConfirm" element={<RegisterConfirmationPage />} />
      <Route path="/registermore" element={<RegisterMoreDetailsPage />} />
      <Route path="/registerfeature" element={<RegisterFeaturePage />} />
      <Route path="/registerneedinfo" element={<RegisterNeedInfoPage />} />
      <Route path="/driver/register" element={<DriverSelfRegisterPage />} />

      {/* Dashboard - Old vs New */}
      {/* <Route path="/overview" element={<Overview />} /> */}
      <Route path="/overview" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />

      {/* Vehicle Routes - Old vs New */}
      {/* <Route path="/Vehicle" element={<Vehicle />} /> */}
      <Route path="/Vehicle" element={<VehiclePage />} />
      {/* <Route path="/vehicle-new" element={<VehiclePage />} /> */}
      {/* <Route path="/vehicle/add" element={<AddVehicle />} /> */}
      <Route path="/vehicle/add" element={<VehicleAddPage />} />
      <Route path="/vehicle/track" element={<ProtectedRoute><DeviceLocationMap /></ProtectedRoute>} />
      {/* <Route path="/vehicle/track" element={<VehicleTrackingPage />} /> */}
      {/* <Route path="/vehicle/TrackAllVehicle" element={<VehicleAllTracker />} /> */}
      <Route path="/vehicle/TrackAllVehicle" element={<TrackVehiclesPage />} />
      <Route path="/vehicle/screen/:vehicleId" element={<VehicleScreen />} />
      <Route path="/vehicle/schedule" element={<ScheduleVehicle />} />
      <Route path="/vehicle/entry-exit" element={<VehicleEntryExitPage />} />
      <Route path="/vehicle/analytical-EntryExit" element={<AnalyticsEntryExitPage />} />

      {/* Routes Routes - Old vs New */}
      {/* <Route path="/Route" element={<Routess />} /> */}
      <Route path="/route" element={<RoutePage />} />
      {/* <Route path="/route-new" element={<RoutePage />} /> */}
      {/* <Route path="/route/add" element={<AddRoute />} /> */}
      <Route path="/route/add" element={<RouteAddPage />} />
      {/* <Route path="/route/track" element={<RouteTrackingPage />} /> */}
      <Route path="/route/track" element={<RouteTrackingComponent />} />
      <Route path="/route/allroutes" element={<AllRouteTrack />} />
      <Route path="/route/screen/:routeId" element={<RouteScreen />} />
      {/* <Route path="/route/schedules/" element={<RouteSchedules />} /> */}
      <Route path="/route/schedules/" element={<RouteSchedule />} />

      {/* Stops Routes - Old vs New */}
      {/* <Route path="/Stops" element={<Stops />} /> */}
      <Route path="/stop" element={<StopPage />} />
      {/* <Route path="/stop-new" element={<StopPage />} /> */}
      <Route path="/stop/add" element={<StopAddUpdatePage />} />
      <Route path="/stop/:stopId" element={<StopAddUpdatePage />} />
      {/* <Route path="/stop/all/map" element={<AllStopsMapPage />} /> */}
      <Route path="/stop/all/map" element={<StopsAllTrack />} />
      <Route path="/track/screen/:stopId" element={<StopsScreen />} />
      <Route path="/stop/track" element={<MapPage />} />
      {/* <Route path="/Stops/Schedule/Details" element={<StopScheduleDetails />} /> */}
      <Route path="/stop/Schedule/Details" element={<StopSchedulePage />} />

      {/* Schedule Routes - Old vs New */}
      {/* <Route path="/schedule" element={<Schedule />} /> */}
      <Route path="/schedule" element={<SchedulePage />} />
      {/* <Route path="/schedule-new" element={<SchedulePage />} /> */}
      {/* <Route path="/schedule/add" element={<AddSchedule />} /> */}
      <Route path="/schedule/add" element={<AddSchedule />} />
      <Route path="/schedule/:scheduleId" element={<AddSchedule />} />

      {/* User Routes - Old vs New */}
      {/* <Route path="/Users" element={<Users />} /> */}
      <Route path="/user" element={<UserPage />} />
      {/* <Route path="/user-new" element={<UserPage />} /> */}
      <Route path="/user/AddUser" element={<AddUser />} />
      <Route path="/user/:Id" element={<AddUser />} />
      <Route path="/user/role" element={<RolePage />} />
      {/* <Route path="/user/role" element={<Role />} /> */}
      {/* <Route path="/user/role/:Id" element={<RoleAccess />} /> */}
      <Route path="/user/role/:Id" element={<RoleAssignPage />} />

      {/* Driver Routes - Old vs New */}
      {/* <Route path="/Driver" element={<Driver />} /> */}
      <Route path="/driver" element={<DriverPage />} />
      {/* <Route path="/driver-new" element={<DriverPage />} /> */}
      <Route path="/AddDriver" element={<AddDriver />} />
      <Route path="/driver/add" element={<DriverAddPage />} />
      {/* <Route path="/driver/add" element={<AddDriver />} /> */}
      <Route path="/attendants" element={<AttendantPage />} />

      {/* Site Routes - Old vs New */}
      {/* <Route path="/Site" element={<Site />} /> */}
      <Route path="/site" element={<SitePage />} />
      {/* <Route path="/site-new" element={<SitePage />} /> */}
      {/* <Route path="/site/add" element={<AddSite />} />
      <Route path="/site/:siteId" element={<AddSite />} /> */}
      <Route path="/site/add" element={<SiteAddPage />} />
      <Route path="/site/:siteId" element={<SiteAddPage />} />

      {/* Alerts and Features - Old vs New */}
      {/* <Route path="/alerts" element={<Alert />} /> */}
      <Route path="/alert" element={<AlertContainer />} />
      <Route path="/driver-behavior" element={<ProtectedRoute><DriverBehaviorPage /></ProtectedRoute>} />
      {/* <Route path="/alert-new" element={<AlertPage />} /> */}
      <Route path="/Feature" element={<Feature />} />
      <Route path="/acess" element={<Feature />} />

      {/* Organization and Admin Routes */}
      {/* <Route path="/organization" element={<Organization />} /> */}
      <Route path="/organization" element={<OrganizationPage />} />
      <Route path="/organizationUpdate/:id" element={<OrganizationUpdate />} />
      <Route path="/organizationUpdate" element={<OrganizationUpdate />} />
      <Route path="/organization/register" element={<Organization />} />
      <Route path="/organization/add" element={<AddOrganization />} />
      {/* <Route path="/organization/feature/:id" element={<FeatureAssignment />} /> */}
      <Route path="/organization/feature/:id" element={<AdminOrgAssign />} />
      <Route path="/organization/viewMore/:id" element={<AdminOrgMore />} />
      <Route path="/admin/add" element={<AddAdmin />} />
      <Route path="/role" element={<Role />} />
      {/* <Route path="/requestDetails" element={<RequestDetails />} /> */}
      <Route path="/request/view/:id" element={<OrganizationUpdate />} />
      <Route path="/request/feature/:id" element={<AdminOrgAssign />} />
      <Route path="/request/viewMore/:id" element={<AdminOrgMore />} />

      {/* Manage Data - Old vs New */}
      {/* <Route path="/managedata" element={<ManageData />} /> */}
      <Route path="/reports/managedata" element={<ManageDataPage />} />
      {/* <Route path="/managedata-new" element={<ManageDataPage />} />d */}
      <Route path="/org" element={<OrganizationList />} />
      <Route path="/reports/analytics" element={<AnalyticsPage />} />

      {/* Catch-all route for Home */}
      <Route path="*" element={<Home />} />
      {/* <Route path='/admin' element={<AdminDashboard/>}/> */}
      <Route path="/admin" element={<AdminRequestPage />} />
      <Route path="/settings" element={<AppSetingsContainer />} />
      <Route path="/console" element={<DriverConsoleContainer />} />

      {/*device*/}
      <Route path="/device" element={<DeviceListPage />} />
      <Route path="/device/add" element={<CreateDevicePage />} />
      <Route path="/device/monitor" element={<DeviceMonitorPage />} />
      <Route path="/device/:deviceId" element={<CreateDevicePage />} />

      {/*reports*/}
      <Route path="/reports" element={<ReportsPage />} />
      <Route path="/replay" element={<ReplayVehicle />} />

      {/*reset password should be public*/}
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/independent/dashboard" element={<DashboardMapURL />} />

      {/*Mobile Stop Screen */}
      <Route
        path="/mobile/stop/:organizationId"
        element={<MobileStopScreen />}
      />
      <Route path="/mobile/stop/bus" element={<BusList />} />

      {/*School Routes */}
      <Route path="/school" element={<SchoolDashboard />} />
      <Route path="/school-students" element={<SchoolStudents />} />
      <Route path="/school-vehicles" element={<SchoolVehicles />} />
      <Route path="/school-attendants" element={<SchoolAttendants />} />
      <Route path="/school-routes" element={<SchoolRoutes />} />
      <Route path="/school-stops" element={<SchoolStops />} />
      <Route path="/school-drivers" element={<SchoolDrivers />} />
      <Route path="/school-users" element={<SchoolUsers />} />
      <Route path="/school-users/add" element={<AddUser />} />
      <Route path="/school-users/:userId" element={<AddUser />} />
      <Route path="/school-users/role" element={<RolePage />} />
      <Route path="/school-users/role/:Id" element={<RoleAssignPage />} />
      <Route path="/school-sites" element={<SchoolSites />} />
      <Route path="/school-sites/add" element={<SiteAddPage />} />
      <Route path="/school-sites/:siteId" element={<SiteAddPage />} />
      <Route path="/school-schedules" element={<SchoolSchedules />} />
      <Route path="/school-schedules/add" element={<AddSchedule />} />
      <Route path="/school-schedules/:scheduleId" element={<AddSchedule />} />
      <Route path="/school-reports" element={<SchoolReports />} />
      <Route path="/school-alerts" element={<SchoolAlerts />} />
      <Route path="/school-settings" element={<SchoolSettingsContainer />} />

      <Route path="/parent-view" element={<ParentView />} />

      <Route
        path="/school-stops/monitor/:stopId"
        element={<SchoolStopMonitor />}
      />


      <Route
        path="/school-vehicles/monitor/:vehicleId"
        element={<SchoolVehicleMonitor />}
      />

      <Route
        path="/school-routes/monitor/:routeId"
        element={<SchoolRouteMonitor />}
      />

    </RouterRoutes>
  );
};

export default Routes;
